import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { viewSettings, hasPermission } from 'actions';
import { ADMINISTRATE_LIVE_WEATHER_CENTER_CHAT } from 'permissions';

class Message extends Component {
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this)
		this.handleDeleteMessage =  this.handleDeleteMessage.bind(this)
	}

	handleClick(event) {
		this.props.viewSettings();
	}

	handleDeleteMessage(event) {
		if(this.props.onDelete)
			this.props.onDelete(this.props.message);
	}

	render() {
		var time = moment(this.props.message.timestamp).fromNow();
		if(time == 'Invalid date')
			time = '';

		var messageClass
		if (this.props.message.creator.admin)
			messageClass = 'met-message-bubble';
		else
			messageClass = 'my-message-bubble';

 		return (
			<div className="message-wrapper">
  			<div className={messageClass}>
  				{(()=>{
						return (
							<div className="avatar-img-wrapper">
								<img
									className="avatar-img"
									src={this.props.message.creator.avatar}
									onClick={this.handleClick}/>
							</div>
						);
  				})()}
					<div className="message">
							<strong>
								{this.props.message.creator.screen_name}
							</strong>
							{''} {time}
  					<p>{this.props.message.body}</p>
  				</div>
  			</div>
  			{(()=>{
					if (this.props.hasPermission(ADMINISTRATE_LIVE_WEATHER_CENTER_CHAT)) {
						return (
							<div id="delete-message-x">
								<a
								onClick={this.handleDeleteMessage}>x</a>
							</div>
						);
					}
					})()}
  		</div>
		);
	}
}

function mapStateToProps(state) {
	return state
}

export default connect(mapStateToProps, { viewSettings, hasPermission })(Message)



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/chat/message.js